module.exports = __webpack_public_path__ + "static/media/cover.bf6670b3.jpg";